import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

const Footer = () => {
  const navigate = useNavigate();

  const handleHashNavigation = (e, href) => {
    e.preventDefault();

    if (href.includes("#")) {
      const [path, hash] = href.split("#");
      const targetPath = path || "/";
      const hashId = hash;

      if (window.location.pathname === targetPath) {
        // Already on the page, just scroll
        const element = document.getElementById(hashId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navigate to the page first, then scroll
        navigate(targetPath);
        setTimeout(() => {
          const element = document.getElementById(hashId);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else if (href.startsWith("/")) {
      navigate(href);
    } else {
      window.location.href = href;
    }
  };

  return (
    <footer className="border-t border-stone-900 bg-stone-950 pt-16 pb-8 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:24px_24px]"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-rose-600 to-orange-600 rounded-lg flex items-center justify-center shadow-lg shadow-rose-500/30">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold text-white text-lg">FaceTraits</span>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-xs">
              Discover your personality through AI-powered image analysis.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">
              Quick Links
            </h4>
            <ul className="space-y-2.5 text-sm text-zinc-500">
              <li>
                <a
                  href="/personality-analysis"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/personality-analysis");
                  }}
                  className="hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Generator
                </a>
              </li>
              <li>
                <a
                  href="/#features"
                  onClick={(e) => handleHashNavigation(e, "/#features")}
                  className="hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="/pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/pricing");
                  }}
                  className="hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">Legal</h4>
            <ul className="space-y-2.5 text-sm text-zinc-500">
              <li>
                <a
                  href="/#faq"
                  onClick={(e) => handleHashNavigation(e, "/#faq")}
                  className="hover:text-teal-400 transition-colors cursor-pointer"
                >
                  FAQs
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/privacy");
                  }}
                  className="hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Privacy
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/terms");
                  }}
                  className="hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-600 text-sm">
            © {new Date().getFullYear()} FaceTraits Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
